<label for="file-upload" *ngIf="label && primaryPractice?.length">{{label}}</label>

<div *ngIf="primaryPractice?.length" class="nuggets-preview-gallery mt-5">
  <app-cloud-picker [data]="previewData"></app-cloud-picker>
</div>
